// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryPrescriber {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryPrescriber.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryPrescriber.discriminator = undefined;
MangoHubGetPatientSummaryPrescriber.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "siteName",
        "baseName": "siteName",
        "type": "string"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    }
];
//# sourceMappingURL=mangoHubGetPatientSummaryPrescriber.js.map